var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-opacity-90 tw-fixed tw-top-0 tw-left-0 tw-h-screen tw-w-screen bgCustom tw-z-40"}),_c('div',{staticClass:"tw-fixed tw-top-0 tw-left-0 tw-h-screen tw-w-screen tw-text-white tw-text-center tw-z-50"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }